import React from "react";
import CustomConfigurator from "../../../CustomConfigurator";
import GenericErrorBoundary from "../../shared/GenericErrorBoundary";

// Customer packs register fields here; their tags live in `extraTags` (claimed from `tags` on edit), merged on submit.
CustomConfigurator.setDefault(["activityComposer", "ExtraFields"], null);

export type ComposerExtraFieldsProps = {
  activity?: { id: string } | null;
  // object type of the edited activity, else the type being composed
  activityType: string;
};

export default function ComposerExtraFields(props: ComposerExtraFieldsProps) {
  const ExtraFields = CustomConfigurator.get([
    "activityComposer",
    "ExtraFields",
  ]) as React.ComponentType<ComposerExtraFieldsProps> | null;

  if (!ExtraFields) return null;

  return (
    <GenericErrorBoundary>
      <ExtraFields {...props} />
    </GenericErrorBoundary>
  );
}
